module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('RefundsTabs'), _vm._v(" "), _c('div', {
    staticClass: "container__table excel",
    staticStyle: {
      "overflow": "hidden",
      "width": "100%",
      "z-index": "-10"
    }
  }, [_c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: (_vm.onSwipe),
      expression: "onSwipe",
      arg: "pan"
    }],
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "width": "100%",
      "z-index": "-10"
    },
    style: ({
      'transform': 'translate3d(' + _vm.x + 'px, 0px, 0px)'
    }),
    attrs: {
      "id": "swipe"
    }
  }, [_c('StatisticTable', {
    attrs: {
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "title": ("" + (_vm.$t('pages.ref_cancel_operators')))
    },
    on: {
      "isPopup": _vm.isPopup
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e0fb2a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/refunds/CancelOperators.vue
// module id = 553
// module chunks = 0